import { useState, useEffect } from "react";
import "../../assets/styles/visits.scss";
import {
  convertToNameLabel,
  fetchOptions,
  dateFormat,
  arrageArrayFunc,
  generateColumnMetadata,
  uniqObjWithNumKey,
  convertToSearchField,
  Feature,
} from "../../utils/utils";
import _ from "lodash";
import { commonPostApi, commonGetApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import ProfileView from '../../components/common/profileView';
import { useParams } from "react-router-dom";
import PrimarySideBar from '../../components/common/sideBar/primarySideBar';
import DataGrid from '../../components/common/dataGrid/dataGrid';
import ButtonWithSearch from '../../components/common/buttonWithSearch';
import { campFormRender } from "../../utils/serviceData";
import { showToast } from '../../components/common/toast';
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../constants/toast";
import { SORT_ORDER } from "../../constants/sortOrder";
import InputIterator from '../../components/common/inputIterator';
import AddButtonSection from '../../components/common/AddButtonSection';
import { useForm } from "react-hook-form";
import CommonModal from '../../components/common/commonModel';
import moment from "moment";
import { Button } from "primereact/button";
import AddImageSection from '../../components/common/AddImageSection';
import InputPrimaryComponents from '../../components/common/inputPrimaryComponents';
import LinearColoredComponent from '../../components/common/linearColoredComponent';
import { nonRequirePatientListField, CampsTableColumns, } from "../../utils/serviceData";

const searchFields = [
  "user_name",
  "email",
  "phone_no",
  "address",
  "role_names"
]

const CampUserList = () => {
  const { id } = useParams();

  const [patient, setPatient] = useState({});
  const [profileLoading, setProfileLoading] = useState(true);
  const [editCampVisible, setEditCampVisible] = useState(false);
  const [formRender, setFormRender] = useState(campFormRender);
  const [loader, setLoader] = useState(false);
  const [addUserRoleVisible, setAddUserRoleVisible] = useState(false);
  const [editUserRoleVisible, setEditUserRoleVisible] = useState(false);
  const [campUser, setCampUser] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [userRole, setuserRole] = useState([]);
  const [uploadedImg, setUploadedImg] = useState({});
  const [assignNum, setAssignNum] = useState();
  const [userSearch, setUserSearch] = useState([]);
  const [navigator, setNavigator] = useState({
    page: 1,
    first: 0,
    rows: 10,
    totalRecords: 1,
    sortBy: "user_name",
    sortDir: SORT_ORDER.ASC,
    searchCriteria: {
      camp_details_id: id,
      ...convertToSearchField(searchFields, "")
    },
  });

  const {
    control,
    formState: { errors, dirtyFields },
    handleSubmit,
    reset,
    watch,
    setValue,
    trigger
  } = useForm({ formRender, mode: "onChange", reValidateMode: "onChange" });

  const [items, setItems] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [editID, setEditID] = useState("");
  const [campUserDetails, SetcampUserDetails] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchNotFound, setSearchNotFound] = useState(false);
  const onSortClick = (event) => {
    setLoading(true);
    const sortOrder = event?.sortOrder === 1 ? SORT_ORDER.ASC : SORT_ORDER.DESC;
    setNavigator((prev) => ({
      ...prev,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    }));
    init({
      ...navigator,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    });
  };

  const onRowCountChange = (e) => {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      rows: e?.target?.value,
      page: 1,
      first: 0,
    }));
    init({
      ...navigator,
      page: 1,
      first: 0,
      rows: e?.target?.value,
    });
  };
  const search = (event) => {
    const query = event.query.toLowerCase();
    const filtered = userSearch
      ?.filter((user) => user?.user_name?.toLowerCase().includes(query))
      ?.map((user) => ({ label: user?.user_name, value: user?.user_id }));
    setItems(filtered);
    filtered.length > 0 ? setSearchNotFound(false) : setSearchNotFound(true);
  };

  const fields = [
    "camp_name",
    "description",
    "organization_id",
    "start_date",
    "end_date",
    "frequency",
    "camp_type_id",
    "pincode",
    "contact_number",
    "contact_name",
    "city",
    "state",
    "district",
    "address",
    "profile_picture"
  ];

  const button = [
    {
      type: "primarySuccessButton",
      label: "Assign User Role",
      class: "mt-2 w-full flex pr-4",
      disabled: loading,
      onClick: () => {
        setAddUserRoleVisible(true);
        setInputValue("");
        reset();
        setSelectedUser(null);
        setSearchNotFound(false);
      },
    },
  ];


  const getAllUsers = async () => {
    try {
      const data = await commonPostApi(API_ENDPOINTS.GET_ALL_USERS, {});
      if (data?.status === 200) {
        setUserSearch(data?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching all users:", error);
    }
  };

  useEffect(() => {
    getAllUsers();
  }, []);



  const initiateForm = () => {
    fetchOptions("CAMP_FREQUENCY", (frequency) => {
      setFormRender((prev) =>
        prev.map((item) => {
          if (item?.name === "frequency") return { ...item, options: frequency };
          else return item;
        })
      );
    });
  };

  const init = async (navigator) => {
    let currentObj = {
      query: {
        page: navigator?.page,
        limit: navigator?.rows,
        sortFields: navigator?.sortFields,
        searchCriteria: navigator?.searchCriteria,
      },
    };
    Promise.all([
      await commonPostApi(API_ENDPOINTS.SEARCH_CAMP_DETAILS, {
        camp_details_id: id,
      }),
      await commonPostApi(API_ENDPOINTS.CAMP_USER_LIST, currentObj),
      await commonGetApi(API_ENDPOINTS.CAMP_TYPE),
      await commonPostApi(API_ENDPOINTS.GET_ALL_ROLES, { camp_details_id: id }),
      await commonGetApi(API_ENDPOINTS.GET_DASHBOARD_ORGANIZATION),
      await commonGetApi(API_ENDPOINTS.GET_ALL_NOTIFICATION_CAMPS),
    ])
      .then(
        async ([
          data = {},
          userDetail,
          camptype,
          allUserRole,
          organization,
          campUserDetails
        ]) => {
          const campDetails = data?.data?.data;
          let userData = userDetail?.data?.data;
          //here in userdata only getting data acording to page

          const role = allUserRole?.data?.data;
          const roleOptions = role
            ?.filter((item) => item?.role_name)
            .map((item) => ({
              label: item?.role_name,
              value: item?.app_role_id,
            }));
          setAssignNum(uniqObjWithNumKey(roleOptions, "label"));
          setuserRole(roleOptions);
          campUser?.forEach((item) => {
            item.role = item?.role_names;
          });
          setNavigator((prev) => ({
            ...prev,
            totalRecords: userDetail?.data?.total,
            page: userDetail?.data?.currentPage,
          }));
          const finalList = {};
          const keyMapping = {
            camp_code: "camp_iD",
            camp_type_name: "type",
            state: "location",
            frequency_name: "frequency",
          };
          [
            "camp_code",
            "start_date",
            "end_date",
            "camp_type_name",
            "frequency_name",
            "state",
          ].forEach((item) => {
            finalList[keyMapping[item] || item] = campDetails[item];
          });

          let finalData = convertToNameLabel(finalList, [
            "camp_name",
            "camp_details_id",
            "description",
            "organization_id",
            "created_at",
            "updated_at",
            "created_by",
            "updated_by",
            "address",
            "city",
            "district",
            "pincode",
            "contact_name",
            "contact_number",
          ]);
          finalData.name = campDetails["camp_name"];
          finalData.imgUrl = campDetails?.profile_picture
            ? `${process.env?.REACT_APP_CURRENT_URL}${API_ENDPOINTS.SEARCH_IMAGE_BY_ID(campDetails?.camp_details_id)}`
            : null;
          setUploadedImg(finalData.imgUrl)
          finalData = Object.entries(finalData)
            .map(([label, value]) => ({ [label]: value }))
            ?.reduce((acc, item) => {
              const normalizedItem =
                Array.isArray(item) && item.length === 1 ? item[0] : item;
              return { ...acc, ...normalizedItem };
            }, {});

          setColumns(
            arrageArrayFunc(
              generateColumnMetadata({
                data: finalData,
                nonRequireField: [...nonRequirePatientListField],
                alias: {
                  user_name: "user_name",
                  role_names: "role_names",
                  email: "email",
                  phone_no: "phone_no",
                  address: "address",
                },
                defaultColumnsArr: CampsTableColumns,
              })
            )
          );
          setCampUser(userData);
          setLoading(false);
          fields.forEach((fieldName) => {
            if (["start_date", "end_date"].includes(fieldName))
              setValue(
                fieldName,
                moment(campDetails?.[fieldName], "DD-MM-YYYY")?._d
              );
            else setValue(fieldName, campDetails?.[fieldName]);
          });
          setFormRender((prev) =>
            prev.map((formInput) => {
              if (formInput?.name === "organization_id") {
                return {
                  ...formInput,
                  options:
                    organization?.data?.data?.map?.((org) => ({
                      ...org,
                      label: org?.organization_name,
                      value: org?.organization_id,
                    })) || [],
                };
              } else if (formInput?.name === "camp_type_id") {
                return {
                  ...formInput,
                  options:
                    camptype?.data?.data?.map?.((org) => ({
                      ...org,
                      label: org?.camp_type_name,
                      value: org?.camp_type_id,
                    })) || [],
                };
              } else return formInput;
            })
          );
          SetcampUserDetails(campUserDetails?.data.data || []);
          setPatient({ finalData, originalData: campDetails });
          setProfileLoading(false);
        }
      )
      .catch((err) => {
        console.log(err);
      });
  };
  const buttonEdit = [
    {
      type: "primarySuccessButton",
      label: "Edit",
      class: "card-button-edit",
      onClick: () => {
        setEditCampVisible(true);

        reset({
          ...patient?.originalData,
          start_date: moment(patient?.originalData?.start_date, "DD-MM-YYYY")
            ?._d,
          end_date: moment(patient?.originalData?.end_date, "DD-MM-YYYY")?._d,
        });

        setUploadedImg(patient?.finalData?.imgUrl);
      },
    },
  ];

  const onEdit = async (data) => {
    if (loader) return;
    setLoader(true);
    let headers = {};
    let editCamp = {
      ...data,
      camp_details_id: id,
      start_date: dateFormat(data["start_date"]),
      end_date: dateFormat(data["end_date"]),
    };

    let finaldata = editCamp;
    if (uploadedImg && uploadedImg.size && uploadedImg.size > 0) {
      finaldata = new FormData();
      finaldata.append("profile_picture", uploadedImg);
      finaldata.append("_payload", JSON.stringify(editCamp));
      headers = { "Content-Type": "multipart/form-data" };
    }
    else {
      headers = {
        "Content-Type": "application/json",
      };
    }
    await commonPostApi(API_ENDPOINTS.EDIT_CAMP_DETAILS, finaldata,
      { headers }
    )
      .then((data) => {
        if (data?.status === 200) {
          showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.CAMP.UPDATED);
          setEditCampVisible(false);
          init({
            ...navigator,
            searchCriteria: {
              ...navigator?.searchCriteria,
              searchvalue: "",
            },
          });
          setLoader(false);
        } else {
          showToast(TOAST_TYPE.ERROR, data?.message ?? COMMON_MSG.ERROR.GENERIC);
          setLoader(false);
        }
      })
      .catch((err) => {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
        setLoader(false);
      });
  };

  const onSubmit = async () => {
    if (loader) return;
    setLoader(true);
    if (uploadedImg?.size > 800 * 1024) {
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.VALIDATION.FILE_SIZE_EXCEEDED);
      setLoader(false);
      return;
    }
    let headers = {
      "Content-Type": "application/json",
    };
    let addUser = {
      camp_details_id: id,
      user_id: selectedUser,
      app_role_id: watch("user_role"),
    };
    let finalData = addUser;
    if (uploadedImg && uploadedImg.size && uploadedImg.size > 0) {
      finalData = new FormData();
      finalData.append("profile_picture", uploadedImg);
      finalData.append("_payload", JSON.stringify(addUser));
      headers = {
        "Content-Type": "multipart/form-data",
      };
    } else {
      headers = {
        "Content-Type": "application/json",
      };
    }
    await commonPostApi(API_ENDPOINTS.ASSIGN_USER_ROLE, addUser, {
      headers,
    })
      .then((data) => {
        if (data?.status === 200) {
          showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.USER.ASSIGNED_TO_CAMP);
          setAddUserRoleVisible(false);
          setInputValue("");
          reset();
          init({
            ...navigator,
            page: 1,
            searchCriteria: {
              ...navigator?.searchCriteria,
              searchvalue: "",
            },
          });
          setLoader(false);
        } else if (
          data?.response?.data?.message ===
          "User is already assigned to this camp."
        ) {
          showToast(TOAST_TYPE.ERROR, FEATURE_MSG.USER.ALREADY_ASSIGNED);
          setLoader(false);
        } else {
          showToast(TOAST_TYPE.ERROR, data?.message ?? COMMON_MSG.ERROR.GENERIC);
          setLoader(false);
        }
      })
      .catch((err) => {
        showToast(TOAST_TYPE.ERROR, err.response?.data?.message ?? COMMON_MSG.ERROR.GENERIC);
        setLoader(false);
      });
  };

  const EditRole = async (FormData) => {
    if (loader) return;
    setLoader(true);
    let headers = {
      "Content-Type": "application/json",
    };
    let editUser = {
      camp_details_id: id,
      user_id: editID,
      app_role_id: watch("edit_role"),
    };
    await commonPostApi(API_ENDPOINTS.EDIT_USER_ROLE, editUser, {
      headers,
    })
      .then((data) => {
        if (data?.status === 200) {
          showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.USER.ROLE_UPDATED);
          setEditUserRoleVisible(false);
          init({
            ...navigator,
            page: 1,
            searchCriteria: {
              ...navigator?.searchCriteria,
              searchvalue: "",
            },
          });
          setLoader(false);
        } else {
          showToast(TOAST_TYPE.ERROR, data?.message ?? COMMON_MSG.ERROR.GENERIC);
          setLoader(false);
        }
      })
      .catch((err) => {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
        setLoader(false);
      });
  };

  const onDelete = async () => {
    if (loader) return;
    setLoader(true);
    let headers = {
      "Content-Type": "application/json",
    };
    let removeUser = {
      camp_details_id: id,
      user_id: editID,
    };
    await commonPostApi(API_ENDPOINTS.REMOVE_USER, removeUser, {
      headers,
    })
      .then((data) => {
        if (data?.status === 200) {
          showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.USER.REMOVED);
          init({
            ...navigator,
            page: 1,
            searchCriteria: {
              ...navigator?.searchCriteria,
              searchvalue: "",
            },
          });
          setLoader(false);
          setVisible(false);
        } else {
          showToast(TOAST_TYPE.ERROR, data?.message ?? COMMON_MSG.ERROR.GENERIC);
          setLoader(false);
        }
      })
      .catch((err) => {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
        setLoader(false);
      });
  };

  const handleSearchChange = (value) => {
    setLoading(true);
    const searchData = convertToSearchField(searchFields, value);
    const newNavigator = {
      ...navigator,
      page: 1,
      first: 0,
      searchCriteria: {
        camp_details_id: navigator.searchCriteria.camp_details_id,
        ...searchData,
      },
    };
    setNavigator(newNavigator);
    init(newNavigator);
  };
  const submitButtons = [
    {
      type: "primarySuccessButton",
      label: "Yes",
      class: "w-8rem pr-3",
      onClick: () => {
        onDelete();
      },
    },
    {
      type: "secondaryButton",
      label: "No",
      class: "w-7rem",
      onClick: () => {
        setVisible(false);
      },
    },
  ];

  const AddUserRolebuttons = [
    {
      type: "primarySuccessButton",
      label: "Submit",
      class: "col-4",
      onClick: handleSubmit(onSubmit),
    },
    {
      type: "primaryCancelButton",
      label: "Cancel",
      class: "col-4",
      onClick: () => {
        setAddUserRoleVisible(false);
      },
    },
  ];

  const editUserRolebuttons = [
    {
      type: "primarySuccessButton",
      label: "Submit",
      class: "col-4",
      onClick: handleSubmit(EditRole),
    },
    {
      type: "primaryCancelButton",
      label: "Cancel",
      class: "col-4",
      onClick: () => {
        setEditUserRoleVisible(false);
      },
    },
  ];

  const EditCampbuttons = [
    {
      type: "primarySuccessButton",
      label: "Submit",
      class: "col-4",
      onClick: handleSubmit(onEdit),
      disabled: loader || (Object.keys(dirtyFields).length === 0 && !uploadedImg)
    },
    {
      type: "primaryCancelButton",
      label: "Cancel",
      class: "col-4",
      onClick: () => {
        setEditCampVisible(false);
        setUploadedImg(patient.finalData.imgUrl);
      },
    },
  ];

  function onPageChange(event) {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      first: event?.first,
      page: event.page + 1,
    }));
    init({
      ...navigator,
      first: event?.first,
      page: event.page + 1,
    });
  }

  const itemRenderer = (item, props) => (
    <div className="p-menuitem-content">
      {item.label === "Edit" && (
        <Button
          className="card-button-edit-secound"
          label="Edit Role"
          onClick={() => {
            setEditUserRoleVisible(true);
            setEditID(props?.props?.itemProp?.user_id);
            setValue("edit_username", props?.props?.itemProp?.user_name || "");
            setValue("edit_role", props?.props?.itemProp?.role_ids);
          }}
        />
      )}
      {item.label === "Delete" && (
        <Button
          className="card-button-delete"
          label="Remove User"
          onClick={() => {
            setEditID(props?.props?.itemProp?.user_id);
            setVisible(true);
          }}
        />
      )}
    </div>
  );

  useEffect(() => {
    init(navigator);
  }, [id]);

  useEffect(() => {
    initiateForm();

  }, []);

  useEffect(() => {
    if (!campUserDetails?.length) return;

    setFormRender((prev) =>
      prev.map((field) => {
        if (field.name === "camp_name") {
          return {
            ...field,
            rules: {
              ...field.rules,
              validate: (value) => {
                if (
                  value?.toLowerCase().trim() ===
                  patient?.originalData?.camp_name?.toLowerCase().trim()
                ) {
                  return true;
                }
                const exists = campUserDetails.some(
                  (camp) =>
                    camp?.camp_details_id !== id &&
                    camp?.camp_name?.toLowerCase().trim() ===
                    value?.toLowerCase().trim()
                );

                return exists ? "Camp Name already exists" : true;
              },
            },
          };
        }
        return field;
      })
    );
    trigger("camp_name")
  }, [campUserDetails, trigger]);

  return (
    <div className="Visits__main-container">
      <ProfileView
        profile={patient?.finalData}
        button={
          Feature?.featureVerify(Feature?.listOfFeature?.campEdit) && buttonEdit
        }
        loading={profileLoading}
        parentClass={"ml-auto"}
      />
      <DataGrid
        header={
          <ButtonWithSearch
            buttons={button}
            searchHeaderLabel={"Users"}
            searchPlaceHolder={"Search Users"}
            isSearchEnabled={true}
            isCalenderEnabled={false}
            isButtonEnabledLeft={false}
            isButtonEnabledRight={true}
            styles={{ gridTemplateColumns: "1fr 400px" }}
            onChange={handleSearchChange}
          />
        }
        onSortClick={onSortClick}
        onPageChange={onPageChange}
        onRowCountChange={onRowCountChange}
        isPaginatorEnabled={true}
        navigator={navigator}
        column={columns}
        customColumn={["role_names"]}
        columnCallBack={(data, title) => {
          return (
            <LinearColoredComponent
              data={data}
              title={title}
              assignNum={assignNum}
            />
          );
        }}
        value={campUser}
        loading={loading}
        sortable={
          (campUser && !_.isArray(campUser)) ||
          (campUser && campUser?.length !== 0)
        }
        optionsView={[
          {
            items: [
              {
                label: "Edit",
                icon: "pi pi-pencil",
                template: itemRenderer,
              },
              {
                label: "Delete",
                icon: "pi pi-upload",
                template: itemRenderer,
              },
            ],
          },
        ]}
      />
      {addUserRoleVisible && (
        <PrimarySideBar
          visible={addUserRoleVisible}
          onHide={() => setAddUserRoleVisible(false)}
          header={<div className="sideBar-header">Assign User Role</div>}
        >
          <div className="">
            <InputPrimaryComponents
              inter
              type="autocomplete"
              label="User Search"
              name="assign_user"
              placeholder="Type to search"
              paddingStyle={true}
              searchIcon
              required
              field="label"
              items={items}
              value={inputValue}
              search={search}
              onChange={(e) => {
                setInputValue(e);
                if (e?.value) {
                  setSelectedUser(e?.value);
                } else if (e === "") {
                  setSelectedUser(null);
                }
              }}
            />
            <div className="mb-3">
              {searchNotFound && inputValue.length > 0 && (
                <small className="text-red-600 inter-400">User Not Found</small>
              )}
            </div>
            <InputPrimaryComponents
              type="multiselect"
              label="Role"
              required
              rules={{ required: "Role is required" }}
              name="user_role"
              fieldLabel="user_role"
              placeholder="Type here"
              options={userRole}
              errors={errors}
              control={control}
            />
          </div>
          <div className="pt-3">
            <AddButtonSection
              disabled={loader || !selectedUser}
              buttons={AddUserRolebuttons}
            />
          </div>
        </PrimarySideBar>
      )}
      {editUserRoleVisible && (
        <PrimarySideBar
          visible={editUserRoleVisible}
          onHide={() => setEditUserRoleVisible(false)}
          header={<div className="sideBar-header">Edit User Role</div>}
        >
          <div className="">
            <InputPrimaryComponents
              type="text"
              label="User Search"
              required
              disabled={true}
              name="edit_username"
              fieldLabel="edit_username"
              errors={errors}
              control={control}
            />
            <InputPrimaryComponents
              type="multiselect"
              label="Role"
              required
              name="edit_role"
              rules={{ required: "Role is required" }}
              fieldLabel="edit_role"
              placeholder="Type here"
              options={userRole}
              errors={errors}
              control={control}
            />
          </div>
          <div className="pt-3">
            <AddButtonSection
              disabled={loader || !editID}
              buttons={editUserRolebuttons}
            />
          </div>
        </PrimarySideBar>
      )}
      {editCampVisible && (
        <PrimarySideBar
          visible={editCampVisible}
          onHide={() => {
            setEditCampVisible(false);
            setUploadedImg(patient?.finalData?.imgUrl);
            reset();
          }}
          header={<div className="sideBar-header">Edit Camp</div>}
        >
          <AddImageSection showImg={uploadedImg} setImg={setUploadedImg} />
          <InputIterator
            control={control}
            errors={errors}
            formRender={formRender}
          />

          <div className="pt-3">
            <AddButtonSection buttons={EditCampbuttons} />
          </div>
        </PrimarySideBar>
      )}
      <CommonModal
        visible={visible}
        header="Remove User"
        onHide={() => setVisible(false)}
      >
        <div>
          <div className="flex justify-content-center pr-4">
            Would you like to remove this user?
          </div>

          <div className="mt-6 ml-2">
            <AddButtonSection buttons={submitButtons} />
          </div>
        </div>
      </CommonModal>
    </div>
  );
};
export default CampUserList;
